// extracted by mini-css-extract-plugin
module.exports = {"root":"Tabs_root__CPDCy","tab":"Tabs_tab__CWhoj","tabActive":"Tabs_tabActive__1Sbfz"};